module.exports = __webpack_public_path__ + "static/logo-90810819de3e3cf0c9935c0bc44c4b1e.png";